import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Container } from "react-bootstrap";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import { createHash } from "../utils/utilFuctions";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { basicAuth } from "../utils/Credentials";

export default function Login2() {
  const [currentStep, setCurrentStep] = useState(1);
  const { setTransactionLoaderState, setUserInfo } = useContext(GlobalContext);
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [username1, setusername1] = useState("");
  const [password1, setpassword1] = useState("");
  const [showpassword1, setShowpassword1] = useState(false);
  // const [username1Error, setusername1Error] = useState("");
  // const [password1Error, setpassword1Error] = useState("");
  const [otp, setOtp] = useState("");
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("success");
  const [showToast, setShowToast] = useState(false);
  const [otpError, setOtpError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((pos) =>
        setPosition({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
        })
      );
    }
  }, []);

  const showCustomToast = (msg, type = "success") => {
    setToastMsg(msg);
    setToastType(type);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };
  const { password, username } = basicAuth;
  const base64Credentials = btoa(`${username}:${password}`);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setTransactionLoaderState(true);

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const isNumeric = /^[0-9]+$/.test(username1);
      const type = isNumeric ? "0" : "1";

      const hashedPassword = await createHash(password1);

      const raw = JSON.stringify({
        us_loginid: username1,
        us_password: hashedPassword,
        step: currentStep.toString(),
        otp: currentStep === 1 ? "string" : otp,
        device: "Web",
        latitude: position.latitude?.toString() || "string",
        longitude: position.longitude?.toString() || "string",
        type: type,
      });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Login/SeoLogin`,
        {
          method: "POST",
           headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: raw,
        }
      );

      const data = await res.json();

      if (data.status === "0") {
        showCustomToast(`${data.data.message}`, "success");

        if (currentStep === 1) {
          setCurrentStep(2);
        } else if (currentStep === 2) {
          setUserInfo(data.data);
          setTimeout(() => {
            navigate("/admin/dashboard", { replace: true });
          }, 100);
        }
      } else {
        showCustomToast(data?.msg, "error");
      }
    } catch (error) {
    }

    setTransactionLoaderState(false);
  };
 
 
  return (
    <div className="seobix-login-page">
      {showToast && (
        <div
          className={`seobix-login-toast ${
            toastType === "success" ? "success" : "error"
          }`}
        >
          {toastMsg}
        </div>
      )}

      <Container
        fluid
        className="seobix-login-shell min-vh-100 d-flex justify-content-center align-items-center"
      >
        <Row className="seobix-login-panel w-100 align-items-stretch">
          <Col lg={6} className="seobix-login-hero d-none d-lg-flex">
            <div className="seobix-login-hero-content">
              <div className="seobix-login-badge">SEO Admin Portal</div>
              <h1>Manage campaigns with clarity and speed.</h1>
              <p>
                Track quota, support, and dashboard activity from one focused
                workspace built for your team.
              </p>
              <div className="seobix-login-stats">
                <div>
                  <strong>24/7</strong>
                  <span>Campaign access</span>
                </div>
                <div>
                  <strong>SEO</strong>
                  <span>Performance tools</span>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6} className="seobix-login-form-col">
            <div className="auth-form-transparent seobix-login-card text-left">
              <div className="d-flex justify-content-center mb-4">
                <img
                  className="seobix-login-logo"
                  src={require("../seoimages/pnglogo.png")}
                  alt="Seobix"
                />
              </div>
              {/* <div className="seobix-login-step">
                Step {currentStep} of 2
              </div> */}
              <h4 className="seobix-login-title text-center">
                Welcome to Seobix!
              </h4>
              <h6 className="seobix-login-subtitle text-center mb-4">
                We're excited to have you here. Let's get you started on an
                amazing journey.
              </h6>

              <form className="seobix-login-form" onSubmit={handleSubmit}>
                <Row>
                  <Col md={12} className="mb-3">
                    <label htmlFor="username1">Username</label>
                    <input
                      type="text"
                      id="username1"
                      className="form-control seobix-login-input"
                      value={username1}
                      onChange={(e) => setusername1(e.target.value)}
                      placeholder="Enter username or mobile number"
                    />
                    {/* {username1Error && (
                      <p className="text-danger">{username1Error}</p>
                    )} */}
                  </Col>

                  <Col md={12} className="mb-3">
                    <label htmlFor="password1">Password</label>
                    <div className="input-group seobix-login-input-group">
                      <span className="input-group-text">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                      <input
                        type={showpassword1 ? "text" : "password"}
                        id="password1"
                        className="form-control seobix-login-input"
                        value={password1}
                        onChange={(e) => setpassword1(e.target.value)}
                        placeholder="Enter password"
                      />
                      <button
                        type="button"
                        className="btn seobix-login-eye-btn"
                        onClick={() => setShowpassword1(!showpassword1)}
                      >
                        <FontAwesomeIcon
                          icon={showpassword1 ? faEyeSlash : faEye}
                        />
                      </button>
                    </div>
                    {/* {password1Error && (
                      <p className="text-danger">{password1Error}</p>
                    )} */}
                  </Col>

                  {currentStep === 2 && (
                    <Col md={12} className="mb-3">
                      <label htmlFor="otp">One-Time Password (OTP)</label>
                      <input
                        type="text"
                        id="otp"
                        className="form-control seobix-login-input"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter OTP"
                      />
                      {otpError && <p className="text-danger">{otpError}</p>}
                    </Col>
                  )}

                  <Col md={12}>
                    <button
                      type="submit"
                      className="btn seobix-login-submit w-100 mt-2" style={{color:"#fff"}}
                    >
                      {currentStep === 1 ? "Submit" : "Submit OTP"}
                    </button>
                  </Col>
                </Row>

                <div className="seobix-login-forgot mt-3 text-center">
                  <Link to="/forget">Forgot password?</Link>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
